import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, IconButton, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import CancelIcon from '@mui/icons-material/Cancel';

interface AlertDialogProps {
    open: boolean,
    accept?: () => void,
    reject?: () => void,
    msg: string,
    acceptText?: string,
    rejectText?: string,
    isLoading?: boolean,
    handleOnClose?: () => void,
    isDraftPopUp?: boolean
}

const ConfirmationDialog = ({ open, accept, reject, msg, acceptText, rejectText, isLoading = false, handleOnClose, isDraftPopUp = false }: AlertDialogProps) => {
    return (
        <Dialog
            open={open}
            onClose={!isDraftPopUp ? reject : handleOnClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <IconButton
                aria-label="close"
                onClick={!isDraftPopUp ? reject : handleOnClose}
                sx={{
                    position: 'absolute',
                    right: 2,
                    top: 2,
                }}
            >
                <CancelIcon color={'primary'} />
            </IconButton>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <Typography sx={{ fontWeight: "500", marginTop: "10px", textAlign: 'center' }}>{msg}</Typography>
                </DialogContentText>
            </DialogContent>
            <DialogActions className="dialogAction" sx={{marginBottom: '10px'}}>
                {rejectText &&
                    <Button
                        onClick={reject}
                        color="primary"
                        variant="outlined"
                        sx={{
                            padding: "6px 11px",
                            minWidth: "70px",
                            textTransform: "capitalize",
                            borderRadius: "100px"
                        }}>
                        <Typography sx={{ textTransform: "capitalize", fontWeight: "500" }}>{rejectText}</Typography>
                    </Button>}
                {acceptText && 
                    <LoadingButton
                        loading={isLoading}
                        onClick={accept}
                        color="primary"
                        variant="contained"
                        autoFocus
                        sx={{
                            padding: "6px 11px",
                            minWidth: "70px",
                            textTransform: "capitalize",
                            borderRadius: "100px"
                        }}
                    >
                        <Typography sx={{ textTransform: "capitalize", fontWeight: "500" }}>{acceptText}</Typography>
                    </LoadingButton>
                }
            </DialogActions>
        </Dialog>
    )
}

export default ConfirmationDialog